import { CaviarWeights, StandardWeightMappings } from './Text/constants.js';
import { Weights } from '../themes/default/typography/typography-tokens.js';

// To Do: remove and just use StandardWeightMappings
// in v8 when legacy typography system is removed
var getResolvedWeight = function getResolvedWeight(fontFamily, textWeight) {
  if ((fontFamily === 'Caviar' || fontFamily === 'Caviar-Market') && CaviarWeights[textWeight]) {
    return CaviarWeights[textWeight];
  }

  if (Weights[textWeight]) {
    return Weights[textWeight];
  }

  return StandardWeightMappings[textWeight];
};
var getResolvedWeightWithTheme = function getResolvedWeightWithTheme(theme, textWeight) {
  return getResolvedWeight(theme.Typography.FontFamily, textWeight);
};

export { getResolvedWeight, getResolvedWeightWithTheme };
